import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;

    .public-layout-section-hero-company {
        max-height: 30em;

        .layout-container {
            .copy {
                margin: 0 auto;
                max-width: 90vw;

                .headline-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .headline {
                        font-size: 1.7em;
                        margin-bottom: .5em;
                        padding: .5em 1em;
                    }

                    .subheadline {
                        font-size: 1.7em;
                    }
                }
            }
        }
    }

    .public-page-about-section-hero-mobile {
        display: none;
    }

    @media all and (max-width: ${vars.tabletL}) {
        .public-layout-section-hero-company {
            .layout-container {
                .copy {
                    .headline-wrapper {
                        .headline {
                            font-size: 1.5em;
                        }

                        .subheadline {
                            font-size: 1.5em;
                        }
                    }
                }
            }
        }
    }

    @media all and (max-width: ${vars.tabletS}) {
        .public-layout-section-hero-company {
            .layout-container {
                .copy {
                    .headline-wrapper {
                        .headline {
                            font-size: 1.3em;
                        }

                        .subheadline {
                            font-size: 1.3em;
                        }
                    }
                }
            }
        }
    }

    @media all and (max-width: ${vars.mobileL}) {
        .public-layout-section-hero-company {
            .layout-container {
                .copy {
                    .headline-wrapper {
                        .headline {
                            font-size: 1em;
                        }

                        .subheadline {
                            font-size: 1em;
                        }
                    }
                }
            }
        }
    }

    @media all and (max-width: ${vars.mobileM}) {
        padding-bottom: 1em;

        .public-layout-section-hero-company {
            display: none;
        }

        .public-page-about-section-hero-mobile {
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: url(/images/about/hero_small.png);
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            padding: 5em 0;

            .copy-mobile {
                padding-top: 5em;

                .headline-wrapper-mobile {
                    text-align: center;
                    font-size: 1.4em;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    .headline-mobile-background {
                        background-position: center;
                        background-size: contain;
                        background-repeat: no-repeat;
                        display: inline-block;
                        min-width: 12em;

                        .headline-mobile {
                            font-weight: 600;
                            padding: .2em 1em;
                        }
                    }
                }
            }
        }
    }
`;